import { types } from "mobx-state-tree";

const BaseTag = types.model("BaseTag");

export { BaseTag };
